import { LoginState } from "global/LoginState";
import { faArrowLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import { AlertState } from "global/AlertState";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import callApi from "services/api";
import * as Yup from "yup";

const ForgotPasswordForm = ({ setLoginActiveView }) => {
  const [handleClick, setHandleClick] = useState(false);
  const [formData, setFormData] = useState(null);
  const [, setAlertMessage] = useRecoilState(AlertState);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const setLoginState = useSetRecoilState(LoginState);

  const formik = useFormik({
    initialValues: {
      registrationNumber: "",
    },
    validationSchema: Yup.object({
      registrationNumber: Yup.string().required("Please enter your username"),
    }),
    onSubmit: async (values) => {
      await forgotPassword(values.registrationNumber);
    },
  });

  const forgotPassword = async (username) => {
    setLoading(true);
    const response = await callApi(
      `/v1/api/fetch/my-security-questions?username=${username}`,
      "GET",
      null,
      false,
      false,
      setAlertMessage,
      navigate,
      setLoginState,
    );
    setLoading(false);
    if (response?.success) {
      const questions = response?.body?.body;
      navigate("/au", {
        state: {
          username: username,
          questions: questions,
        },
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      formik.handleSubmit();
    }
  };

  return (
    <div className="row justify-content-center">
      <div className="col-md-8">
        <div className="card">
          <div className="card-face card-front">
            <div className="card-body">
              <h3 className="card-title text-center">Forgot Password</h3>
              <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                <div className="mb-3">
                  <label
                    htmlFor="registrationNumber"
                    className="form-label mt-3"
                  >
                    Username
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="registrationNumber"
                    name="registrationNumber"
                    className={`form-control ${
                      formik.touched.registrationNumber &&
                      formik.errors.registrationNumber
                        ? "is-invalid"
                        : ""
                    }`}
                    {...formik.getFieldProps("registrationNumber")}
                    placeholder="Enter Username"
                    autoComplete="registrationNumber"
                    maxLength={100}
                  />
                  {formik.touched.registrationNumber &&
                    formik.errors.registrationNumber && (
                      <div className="invalid-feedback">
                        {formik.errors.registrationNumber}
                      </div>
                    )}
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    type="submit"
                    className="btn btn-info w-100"
                    disabled={loading}
                  >
                    {loading && (
                      <>
                        <FontAwesomeIcon icon={faSpinner} className="me-2" />
                      </>
                    )}
                    Forgot Password
                  </button>
                </div>
              </form>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-link"
                  onClick={() => setLoginActiveView("login")}
                >
                  <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
